export const APP_ROUTES = {
  HOME: "/",
  SIGN_IN: "/SignIn",

  // All Staff
  ADVISERS: "/Advisers",
  // ADVISER_REGULATORY_WORDING_UPDATES: "/advisers/regulatory-wording-updates",
  ADVISER_MAP: "/AdviserMap",
  STAFF_HOLIDAY: "/staff-holiday",
  GROUP_DETAILS: "/GroupDetails",

  // Adviser Support
  ENQUIRIES: "/Enquiries",
  CONTACT_LIST: "/ContactList",

  // Compliance
  APPLICATIONS: "/Applications",
  RECRUITMENT_REFERENCING: "/recruitment/referencing/:adviserId",
  RECRUITMENT_CONTRACT_DRAFTING: "/recruitment/contract-drafting/:adviserId",
  HIGH_RISK_COUNTRIES: "/HighRiskCountries",
  FINANCIAL_PROMOTIONS: "/FinancialPromotions",
  MEMBERS_HUB: "/MembersHub",
  ONE_AIN: "/1-AIN",
  PROVIDER_INDEX: "/provider-index",
  LICENCE_CERTIFICATES: "/advisers/licence-certificates/summary",
  IFA_RATES: "/finance/ifa-rates",
  IFA_RATES_BULK_UPLOAD: "/finance/ifa-rates/bulk-upload",
  PLAN_TYPE_MAPPING: "/compliance/io-plan-type-mapping",
  COMPLIANCE_REPORTS: "/compliance/reports",
  CLIENT_AGREEMENT_FEE_STRUCTURES: "/compliance/client-agreement-fee-structures",
  PLAN_TYPE_MAPPING_EDIT: "/compliance/io-plan-type-mapping/:planTypeId/edit",

  // Intelliflo
  INTELLIFLO_ADVISER_GATING: "/intelliflo/adviser-gating",
  INTELLIFLO_IO_ID_BULK_UPLOAD: "/intelliflo/io-adviser-ids/bulk-upload",
  // Finance
  CONVERT_COMMISSION_STATEMENTS: "/ConvertCommissionStatements",
  CHECK2_STATEMENTS: "/check²/Statements",
  PARAPLANNING_CHARGES: "/paraplanning-charges",
  PARAPLANNING_SALARIES: "/paraplanning-salaries",
  PRO_CEDING_STATEMENTS: "/pro-ceding-statements",
  COMMISSION_SPLIT_EVENTS: "/finance/commission-split-events",
  FEES_PAID: "/finance/fees-paid",
  FCI_REPORTS: "/finance/fci-reports",
  LIVE_FCI_STATEMENTS: "/finance/live-fci-statements",
  PROVIDER_MATCHES: "/finance/provider-matches",
  MONTHLY_PAYMENTS: "/finance/monthly-payment",
  CHARGES_SUMMARY_DASHBAORD: "/finance/monthly-payment/charges-summary",
  CHARGES_BREAKDOWN: "/finance/monthly-payment/charges-breakdown",
  CHARGES_BREAKDOWN_ADVISER: "/finance/monthly-payment/charges-breakdown/:adviserEmail",
  CHARGES_BREAKDOWN_ADVISER_CHARGE: "/finance/monthly-payment/charges-breakdown/:adviserEmail/charge",
  CHARGES_BREAKDOWN_ADVISER_PAYMENT: "/finance/monthly-payment/charges-breakdown/:adviserEmail/payment",
  Guidelines: "/finance/guidelines",

  // Paraplanning
  PARAPLANNING_DASHBOARD: "/paraplanning",
  PARAPLANNING_CHARGES_VIEW: "/paraplanning/charges-view",

  // Marketing
  MARKETING: "/Marketing",
  MARKETING_ANNOUNCEMENTS: "/department/marketing/announcements",
  MARKETING_WEBSITES: "/department/marketing/design⁴",
  MARKETING_WEBSITE_NEW: "/department/marketing/design⁴/new",
  MARKETING_WEBSITE_DETAILS: "/department/marketing/design⁴/:websiteId",
  MARKETING_PRINTING_NEW: "/department/marketing/printing/new",
  MARKETING_PRINTING_DETAILS: "/department/marketing/printing/:printingId",
  MARKETING_EMAIL_LICENCE_NEW: "/department/marketing/email-licences/new",
  MARKETING_EMAIL_LICENCE_DETAILS:
    "/department/marketing/email-licences/:licenceId",
  SOCIAL_MEDIA_CONTENT_MANAGEMENT: "/social-media-content-management/dashboard",
  SOCIAL_MEDIA_CONTENT_CREATION:
    "/social-media-content-management/dashboard/create",
  SOCIAL_MEDIA_CONTENT_RESPONSE_DETAIL:
    "/social-media-content-management/responses/:responseId",

  // Administrator
  STAFF_ACCESS_OVERVIEW: "/Administrator/AccessOverview",
  SECRET_SANTA: "/Administrator/SecretSanta",
  FIRESTORE_COLLECTION_COPY: "/Administrator/FirestoreCopy",

  // Departments
  DEPARTMENT_ALL_STAFF: "/Department/AllStaff",
  DEPARTMENT_ADVISER_SUPPORT: "/Department/AdviserSupport",
  DEPARTMENT_MARKETING: "/Department/Marketing",
  ADVISER_PORTAL: "https://www.adviser.rosemountfs-ifa.co.uk/",
};

export const buildRoute = {
  recruitmentReferencing: (adviserId) =>
    `/recruitment/referencing/${encodeURIComponent(adviserId)}`,
  recruitmentContractDrafting: (adviserId) =>
    `/recruitment/contract-drafting/${encodeURIComponent(adviserId)}`,
  socialMediaContentResponseDetail: (responseId) =>
    `/social-media-content-management/responses/${encodeURIComponent(
      responseId,
    )}`,
};

